import { useEffect, useState } from 'react';

export const useKeyDown = (fn: (key: string) => void) => {
    useEffect(() => {
        const keyHandler = (event: KeyboardEvent): void => {
            fn(event.key);
        };
        document.addEventListener('keydown', keyHandler, false);
        return () => {
            document.removeEventListener('keydown', keyHandler, false);
        };
    }, [fn]);
};

export const useDebouncedType = (delay = 250) => {
    const [value, setValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState('');

    // Update the value when a key is pressed
    useEffect(() => {
        const keyHandler = (event: KeyboardEvent): void => {
            setValue((current) => current + event.key);
        };
        document.addEventListener('keydown', keyHandler, false);
        return () => {
            document.removeEventListener('keydown', keyHandler, false);
        };
    }, []);

    // Update the debounced value after a certain amount of time
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    // Clear the value after inactivity
    useEffect(() => {
        const timer = setTimeout(() => setValue(''), delay * 3);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
};
